var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    { staticClass: "plan billing-plan-overview", class: "plan-" + _vm.plan.id },
    [
      _c(
        "section",
        [
          _c("h1", [_vm._v(_vm._s(_vm._f("text")(_vm.plan.name)))]),
          _vm._v(" "),
          _c("Cell", {
            staticClass: "price",
            attrs: {
              item: _vm.plan,
              field: _vm.priceField,
              name: _vm.priceFieldName
            }
          }),
          _vm._v(" "),
          _c("Cell", {
            staticClass: "credits",
            attrs: { item: _vm.plan, field: _vm.creditField, name: "credits" }
          }),
          _vm._v(" "),
          _c("Item", {
            staticClass: "striped",
            attrs: { item: _vm.plan, fields: _vm.fields[0] }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("h2", [_vm._v(_vm._s(_vm._f("trans")("billings:support")))]),
          _vm._v(" "),
          _c("Item", {
            staticClass: "striped",
            attrs: { item: _vm.plan, fields: _vm.fields[1] }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c476c3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c476c3c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/sections/billings/components/PlanOverview.vue
// module id = null
// module chunks = 